export enum FrictionType {
  Weak = 'weak',
  Medium = 'medium',
  Strong = 'strong',
}
